import React, { useState } from "react";
import { Form, Upload, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { createSponsor } from "../../../../api/sponsor";
import colors from "../../../../share/constants/constants";
import Button from "../../../../components/common/button";

const SponsorForm = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [form] = Form.useForm();

  const beforeUpload = (file) => {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/webp";
    const isLt1M = file.size / 1024 / 1024 <= 1;

    if (!isJpgOrPng) {
      message.error({
        content: 'You can only upload JPG, PNG, or Webp file formats!',
        style: { marginTop: '20px' },
        duration: 4,
      });
    }
    
    if (!isLt1M) {
      const actualSize = (file.size / 1024 / 1024).toFixed(2);
      message.error({
        content: `Image size (${actualSize} MB) exceeds the 1 MB limit. Please select a smaller one.`,
        style: { marginTop: '20px' },
        duration: 4,
      });
    }
    
    return { isJpgOrPng, isLt1M };
  };

  const handleImageUpload = (info) => {
    const { file } = info;
    const validImage = beforeUpload(file);
    
    if (validImage.isJpgOrPng && validImage.isLt1M) {
      setImageFile(file);
      form.setFieldValue("file", file);
    }
  };

  const onFinish = async (values) => {
    if (!imageFile) {
      message.error("Please upload an image");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("file", imageFile);

    try {
      const response = await createSponsor(formData);
      if (response) {
        message.success("Sponsor created successfully!");
        form.resetFields();
        setImageFile(null);
        onSuccess && onSuccess();
      }
    } catch (error) {
      console.error("Error creating sponsor:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      <h3 className="text-lg font-semibold ">Create New Sponsors</h3>
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
      >
        <Form.Item
          name="image"
          label="Sponsor Image"
          rules={[
            {
              required: true,
              message: "Please upload an image",
            },
          ]}
        >
          <Upload
            listType="picture-card"
            showUploadList={false}
            beforeUpload={() => false}
            onChange={handleImageUpload}
            accept="image/jpeg,image/png,image/webp"
          >
            <div>
              <PlusOutlined />
              <div style={{ marginTop: 8 }}>Upload</div>
            </div>
          </Upload>
        </Form.Item>

        {imageFile && (
          <div className="mb-4">
            <img
              src={URL.createObjectURL(imageFile)}
              alt="preview"
              style={{ width: "200px", height: "auto" }}
              className="object-contain"
            />
          </div>
        )}

        <Form.Item>
          <Button
            color={colors.primaryBlue}
            title="Create Sponsor"
            htmlType="submit"
            loading={loading}
            className="w-lg"
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default SponsorForm;